<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Editar secciones</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap row justify-center>
              <v-flex xs6 sm3>
                <v-img :src="require('@/assets/panel/home/SKLB-Dispositivos.png')"></v-img>
              </v-flex>
              <v-flex xs12>
                <p>Secciones</p>
                <v-select
                  chips
                  multiple
                  :items="sections"
                  v-model="sectionForm.selected"
                  return-object
                  :item-text="text"
                  :error-messages="sectionErrors"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="working.w" flat @click="close">Cancelar</v-btn>
          <v-btn :disabled="working.w" color="primary darken-1" flat @click="update">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading v-model="working.w" text="Trabajando..."></loading>
    <success v-model="toast.success" text="Creación Exitosa"></success>
    <error v-model="toast.failed" text="Ups ocurrió un error"></error>
  </div>
</template>

<script>
import loading from "../Dialogs/Loading.vue";
import success from "../Dialogs/Success.vue";
import error from "../Dialogs/Error.vue";
export default {
  components: {
    loading,
    success,
    error
  },
  props: ["value", "profile", "branch"],
  filters: {
    translateSections(value) {
      switch (value) {
        case "PICK_UP":
          return "Entregas";
        case "NOTICE":
          return "Comunidad";
        case "THIRD_QR":
          return "Terceros";
        case "NOTIFICATION":
          return "Notificaciones";
        case "ROUND_PICK_UP":
          return "Entregas ronda";
        case "STUDENTS":
          return "Alumnos";
        case "ROUNDS":
          return "Rondas";
        case "CARS":
          return "Carros";
        case "PROFILE":
          return "Perfil";
        case "CHOFERS":
          return "Chofer";
        case "QR_PROFILE":
          return "Perfil QR";
        case "NOTIFICATIONS_SETTINGS":
          return "Configuración de notificaciones";
      }
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.sectionForm.selected = this.profile.mobileCatalogs;
      }
    },
    profile() {
      if (this.profile) {
        this.sectionForm.selected = this.profile.mobileCatalogs;
      }
    }
  },
  mounted() {
    if (this.profile) {
      this.sectionForm.selected = this.profile.mobileCatalogs;
    }
  },
  data: () => ({
    sections: [
      {
        id: 1,
        name: "PICK_UP"
      },
      {
        id: 2,
        name: "ROUND_PICK_UP"
      },
      {
        id: 3,
        name: "THIRD_QR"
      },
      {
        id: 4,
        name: "NOTICE"
      },
      {
        id: 5,
        name: "STUDENTS"
      },
      {
        id: 6,
        name: "ROUNDS"
      },
      {
        id: 7,
        name: "CARS"
      },
      {
        id: 9,
        name: "CHOFERS"
      },
      {
        id: 10,
        name: "QR_PROFILE"
      },
      {
        id: 11,
        name: "NOTIFICATIONS_SETTINGS"
      }
    ],
    sectionForm: {
      selected: []
    },
    working: {
      w: false
    },
    toast: {
      success: false,
      failed: false
    }
  }),
  validations: {
    sectionForm: {
      selected: {
        onlyOne() {
          return this.sectionForm.selected.length > 0 ? true : false;
        }
      }
    }
  },
  methods: {
    text(item) {
      return this.$options.filters.translateSections(item.name);
    },
    close() {
      this.$v.$reset();
      this.sectionForm.selected = [];
      this.$emit("input", !this.value);
    },
    update() {
      this.$v.sectionForm.$touch();
      if (!this.$v.$invalid) {
        this.working.w = true;
        var branch = {
          id: this.branch.id,
          profiles: [
            {
              id: this.profile.id,
              mobileCatalogs: this.sectionForm.selected
            }
          ]
        };
        var json = JSON.stringify(branch); // aqui tienes la lista de objetos en Json
        var obj = JSON.parse(json);
        this.$store
          .dispatch("branch/updateBranch", obj)
          .then(response => {
            this.working.w = false;
            this.toast.success = true;
            this.$emit("edited", this.sectionForm.selected);
            this.close();
          })
          .catch(error => {
            this.working.w = false;
            this.toast.failed = true;
            console.log(error);
          });
      }
    }
  },
  computed: {
    sectionErrors() {
      const errors = [];
      if (!this.$v.sectionForm.selected.$dirty) return errors;
      !this.$v.sectionForm.selected.onlyOne &&
        errors.push("Debes seleccioanr al menos una sección");
      return errors;
    }
  }
};
</script>

<style >
</style>